import React from 'react';
import TabNav, { provideSlideMenu } from '@/components/slide-menu/tab-nav';
import Container from '@/components/container';
import './index.less';

export default function CrossCategoryMarketing(props: React.PropsWithChildren<{}>) {
  return (
    <provideSlideMenu.Provider value={{ children: props.children }}>
      <Container marginSize="max">
        <div className="cross-category-head">跨品类营销</div>
        <TabNav />
      </Container>
      {props.children}
    </provideSlideMenu.Provider>
  );
}
